import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import { getPrimaryTier } from '../../DeviationViews/_helpers';

export interface Props {
  primaryTier?: PapiDeviation;
}

export const PrimaryTierContext = React.createContext<Props>({
  primaryTier: undefined,
});
PrimaryTierContext.displayName = 'PrimaryTierContext';

export const PrimaryTierContextProvider: React.FC<React.PropsWithChildren<Props>> = ({
  primaryTier,
  children,
}) => <PrimaryTierContext.Provider value={{ primaryTier }}>{children}</PrimaryTierContext.Provider>;
PrimaryTierContextProvider.displayName = 'PrimaryTierContextProvider';

export function usePrimaryTier(deviation?: PapiDeviation): PapiDeviation | undefined {
  const { primaryTier: contextualTier } = React.useContext(PrimaryTierContext);
  return contextualTier || getPrimaryTier(deviation);
}
